"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";

const routes = [
  {
    label: "Главная",
    href: "/",
  },
  {
    label: "Разместить продукт",
    href: "/submit",
  },
  {
    label: "Сообщество",
    href: "/community",
  },
  {
    label: "О проекте",
    href: "/about",
  },
];

interface MainNavigationProps {
  className?: string;
  onLinkClick?: () => void;
}

export function MainNavigation({ className, onLinkClick }: MainNavigationProps) {
  const pathname = usePathname();

  return (
    <nav className={cn("flex items-center gap-1", className)}>
      {routes.map((route) => {
        const isActive = pathname === route.href;
        return (
          <Link
            key={route.href}
            href={route.href}
            onClick={onLinkClick}
            className={cn(
              "px-3 py-2 text-sm font-medium rounded-md transition-colors",
              "hover:bg-accent hover:text-accent-foreground",
              isActive
                ? "bg-accent text-accent-foreground"
                : "text-muted-foreground"
            )}
          >
            {route.label}
          </Link>
        );
      })}
    </nav>
  );
}
